import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../../Styles/PageStyles";
import Images from "../../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../../Config";
import moment from "moment";
import { capitalizeFirstLetter, getModeName, truncateText } from "../../../helpers";
import { MdOutlineChevronRight, MdDelete } from "react-icons/md";
import Tooltip from "../../Tooltip";

const RecurringTable = ({
  apiData,
  filter,
  setIsViewExpense,
  setSelectedData,
  setIsMarkPaidExpense,
  currentPageIndex,
  setCurrentPageIndex,
  setIsDeleteExpense
}) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(currentPageIndex);
  const [openActionMenu, setOpenActionMenu] = useState(null);

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const pageIndexRef = React.useRef(0);

  const viewExpense = (item) => {
    setCurrentPageIndex(pageIndexRef.current);
    setIsViewExpense(true);
    setSelectedData(item)
    setOpenActionMenu(null);
  };

  const deleteExpense = (item) => {
    setCurrentPageIndex(pageIndexRef.current);
    setIsDeleteExpense(true);
    setSelectedData(item)
    setOpenActionMenu(null);
  };

  const markAsPaid = (item) => {
    setIsMarkPaidExpense(true);
    setSelectedData(item);
  };

  const ActionBtns = (item) => {
    if (filter === "RE") {
      return (
        <Tooltip label="View details">
          <button
            onClick={() => viewExpense(item)}
            className="px-2 ml-auto text-gray-400 hover:text-gray-700 transition"
            title="View details"
          >
            <MdOutlineChevronRight size={22} />
          </button>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip label="Delete expense">
          <button
            onClick={() => deleteExpense(item)}
            className="px-2 ml-auto text-gray-400 hover:text-gray-700 transition"
          >
            <MdDelete size={22} />
          </button>
        </Tooltip>
      );
    }
  };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => {
        const dateDisplay = (filter === "RE" || filter === "UM")
          ? <span className="text-sm text-gray-600 cursor-pointer" onClick={() => viewExpense(item)}>{moment(item.dueDate).format("DD, MMM YY")}</span>
          : <span className="text-sm text-gray-600 cursor-pointer" onClick={() => viewExpense(item)}>{moment(item.paidDate).format("DD, MMM YY")}</span>;

        const paymentModeDisplay = filter === "RE"
          ? null
          : filter === "UM"
            ? <button
              onClick={() => markAsPaid(item)}
              className="
            text-sm px-3 py-1 rounded-full
            border border-gray-400 text-gray-600
            hover:bg-gray-100 hover:border-gray-500
            transition"
            >
              Mark Paid
            </button>

            : getPaymentMode(getModeName(item.paymentMethod));

        return {
          category: (
            <span className="pl-2 text-sm text-gray-700 truncate max-w-[180px] block">
              {item?.name ? truncateText(item.name, 25) : "--"}
            </span>
          ),
          amount: getAmount(item),
          date: dateDisplay,
          paidBy: getPaidBy(item),
          paidTo: getPayableTo(item),
          paymentMode: paymentModeDisplay,
          // property: item.property,
          repetation: getRepetation(item.repetition),
          action: ActionBtns(item),
          description: item.description,
          property: getProperty(item)
        };
      });
      setData(tempData);
    }
  }, [apiData, openActionMenu, filter]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getPayableTo = (item) => {
    return (
      <span className="text-sm text-gray-600 cursor-pointer block max-w-[160px] break-words line-clamp-2" onClick={() => viewExpense(item)}>{capitalizeFirstLetter(item?.paidToName || 'N/A')}</span>
    );
  };

  // const getProperty = (item) => {
  //   const propertyName = item?.propertyList?.[0]?.name;

  //   return (
  //     <span className="text-gray-600 text-sm" >
  //       {propertyName && propertyName.trim() !== ""
  //         ? capitalizeFirstLetter(truncateText(propertyName, 30))
  //         : "--"
  //       }
  //     </span>
  //   );
  // };

  const getProperty = (item) => {
    const name = capitalizeFirstLetter(item?.propertyList?.[0]?.name || 'N/A');
    return (
      <span className="text-gray-600 text-sm block max-w-[160px] break-words line-clamp-2">
        {truncateText(name, 35)}{" "}
      </span>
    );
  };


  const getPaymentMode = (value) => {
    let style;
    if (value === "UPI") {
      style = "bg-green-100 text-green-600";
    } else if (value === "Card") {
      style = "bg-lime-100 text-lime-600";
    } else if (value === "Netbanking") {
      style = "bg-blue-100 text-blue-600";
    } else {
      style = "bg-violet-100 text-violet-600";
    }
    return (
      <span className={`${style} px-3 py-1 rounded-md text-sm`} >{value}</span>
    );
  };

  const getRepetation = (repetation) => {
    if (repetation === 1) {
      return <p>One Time</p>;
    } else if (repetation === 2) {
      return <p>Monthly</p>;
    }
  };

  const getAmount = (item) => (
    <span className="text-sm font-semibold text-gray-600">
      ₹{item.amount}
    </span>
  );

  const getAmountOld = (item) => {
    return <Amount>₹{item.amount}</Amount>
  };

  const getPaidBy = (item) => {
    return (
      <UserImageWrapper>
        <div className="flex flex-col text-left">
          <span className="text-gray-600 text-sm">
            {item.paidByName}{" "}
          </span>
        </div>
      </UserImageWrapper>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const shouldShowColumn = filter === "UM";

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Property",
          accessor: "property",
        },
        {
          Header: "Category",
          accessor: "category",
        },
      ];
    }

    const baseColumns = [
      {
        Header: "Category",
        accessor: "category",
      },
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "Property",
        accessor: "property",
      },
      {
        Header: "Payable To",
        accessor: "paidTo",
      },
      ...(shouldShowColumn ? [
        {
          Header: filter === "UM" ? "Action" : "Payment Mode",
          accessor: "paymentMode",
        }
      ] : []),

      {
        Header: filter === "RE" || filter === "UM" ? "Due Date" : "Paid On",
        accessor: "date",
      },
      {
        Header: "",
        accessor: "action",
      },
    ];

    return baseColumns;
  }, [isMobileView, filter]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    pageIndexRef.current = pageIndex;
    setCurrentPage(pageIndex);
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Amount:</strong>{" "}
                          {data[rowIndex].amount}
                        </li>
                        <li>
                          <strong>{filter === "RE" || filter === "UM" ? "Due Date:" : "Paid On:"}</strong>{" "}
                          {data[rowIndex].date}
                        </li>

                        <li>
                          <strong>Paid To:</strong>{" "}
                          {data[rowIndex].paidTo}
                        </li>

                        {filter !== "RE" && (
                          <li>
                            <strong>{filter === "UM" ? "Action:" : "Payment Mode:"}</strong>{" "}
                            {data[rowIndex].paymentMode}
                          </li>
                        )}

                        <li>
                          <strong>Description:</strong>{" "}
                          {data[rowIndex].description}
                        </li>

                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50 text-gray-800`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-1 text-sm md:p-2 text-left`;
const Amount = tw.p`text-gray-600 text-sm font-medium flex bg-neutral-100 px-3 py-1 rounded-md inline-flex`
const Category = tw.p`pl-2 text-gray-600 text-sm items-center mt-0.5`
export default RecurringTable;